<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title id="file" title="审批记录" />
      </div>

      <div class="section-content" style="width: 1200px">
        <jczh-table-content :data="listData" :option="listOption">
          <template v-slot:last>
            <el-table-column
              label="操作"
              align="center"
              width="100"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <el-button type="text" @click="handleLook(row)">
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </template>
        </jczh-table-content>
      </div>
      <approval-drawer v-model="isDrawerShow" :workflow-id="workflowId" />
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import ApprovalDrawer from '@/components/workflow/ApprovalDrawer'
import {
  workflowAuditCheckDict,
  workflowAuditStatusDict
} from '@/dictionary/workflow'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    BaseSectionTitle,
    ApprovalDrawer
  },

  props: {
    recordList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      isDrawerShow: false,
      workflowId: '',
      listOption: [
        {
          label: '审批完成时间',
          prop: 'endTime'
        },
        {
          label: '发起人',
          prop: 'initiatorName'
        },
        {
          label: '审批类型',
          prop: 'workflowType'
        },
        {
          label: '审批信息',
          prop: 'executorInfo'
        },
        {
          label: '审批结果',
          prop: 'status',
          filter: value => workflowAuditCheckDict.translate(value).label
        }
      ],
      listData: []
    }
  },

  computed: {
    ...mapState('workflow', ['workflowBusinessList', 'workflowBusinessObject']),

    workflowBusinessDictList() {
      return [
        { label: '全部', value: '' },
        ...(this.workflowBusinessList || [])
      ]
    },

    workflowBusiness: {
      get() {
        const temp = [this.filterForm.businessType]
        this.filterForm.businessNode && temp.push(this.filterForm.businessNode)
        return temp
      },
      set(newVal) {
        this.filterForm.businessType = newVal[0] || ''
        this.filterForm.businessNode = newVal[1] || ''
      }
    },

    employeeIdList: {
      get() {
        return this.filterForm.initiatorId
          ? this.filterForm.initiatorId.split(',').map(v => Number(v))
          : []
      },
      set(val) {
        if (Array.isArray(val)) {
          this.filterForm.initiatorId = val.join(',')
        }
      }
    }
  },

  watch: {
    recordList: {
      handler: function(val) {
        this.listData = []
        if (val && val.length) {
          val.forEach(item => {
            let obj = {}
            if (item.status == 4) {
              obj = {
                initiatorName: item.initiatorName,
                endTime: item.endTime,
                workflowType: `${
                  this.workflowBusinessObject[item.businessType]
                }/${this.workflowBusinessObject[item.businessNode]}`,
                executorInfo: `${item.initiatorName}(${
                  workflowAuditCheckDict.translate(item.status).label
                })`,
                status: item.status,
                workflowId: item.workflowId
              }
            } else {
              const executorInfo = []
              if (item?.currentTaskList && item?.currentTaskList.length) {
                item.currentTaskList.map(val => {
                  const str = `${val?.executorName}(${
                    workflowAuditStatusDict.translate(
                      val?.reviewResult
                    ).label
                  })`
                  executorInfo.push(str)
                })
              }
              obj = {
                initiatorName: item.initiatorName,
                endTime: item.endTime,
                workflowType: `${
                  this.workflowBusinessObject[item.businessType]
                }/${this.workflowBusinessObject[item.businessNode]}`,
                executorInfo: executorInfo.join(','),
                status: item.status,
                workflowId: item.workflowId
              }
            }
            this.listData.push(obj)
          })
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('workflow', ['getWorkflowBusinessDict']),

    handleLook(row) {
      this.workflowId = row.workflowId
      this.isDrawerShow = true
      console.log('查看详情')
    }
  }
}
</script>
